module.exports = __webpack_public_path__ + "img/BI1.7c66e052.png";